import api from './api';

export const contactPropertyService = {
  getContactProperties: async (projectId) => {
    const response = await api.get('/contactproperties', { params: { project: projectId } });
    return response.data;
  },

  getContactProperty: async (id) => {
    const response = await api.get(`/contactproperties/${id}`);
    return response.data;
  },

  createContactProperty: async (data) => {
    const response = await api.post('/contactproperties', data);
    return response.data;
  },

  updateContactProperty: async (id, data) => {
    const response = await api.put(`/contactproperties/${id}`, data);
    return response.data;
  },

  deleteContactProperty: async (id) => {
    const response = await api.delete(`/contactproperties/${id}`);
    return response.data;
  }
};
